<template>
    <div class="meta-referrals">
        <div class="header">
            <h5>{{ $t('message.metaReferrals') }}</h5>
        </div>
        <div class="content">
            <div class="referrals">
                <div v-if="contact.metaReferrals.length === 0" class="no-referrals">
                    <i class="fas fa-info-circle"></i>
                    <p>{{ $t('message.noMetaReferrals') }}</p>
                </div>
                <div v-else>
                    <div class="referrals-item" v-for="ad of contact.metaReferrals" :key="ad.id">
                        <div class="headline">
                            <a :href="ad.sourceLink">{{ ad.headline }}</a>
                            <div class="time">{{ $moment(ad.createdAt).fromNow() }}</div>
                        </div>
                        <div class="description">{{ ad.body }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "MetaReferrals",
    components: {},
    props: {
        contact: {
            type: Object,
            default: () => ({}),
        },
    },
    data: () => ({}),
    methods: {},
};
</script>
<style lang="scss" scoped>
.meta-referrals {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
    font-family: "Poppins", sans-serif;

    .header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        flex-direction: column;
    }

    .content {
        .referrals {
            display: flex;
            flex-direction: column;
            gap: 4px;

            .no-referrals {
                font-size: 14px;
                color: #999;
                text-align: center;
                padding: 20px;
                display: flex;
                flex-direction: column;
                align-items: center;

                i {
                    font-size: 24px;
                    margin-bottom: 10px;
                }

                p {
                    margin: 0;
                }
            }

            &-item {
                border: 1px solid #eee7ff;
                padding: 10px;
                border-radius: 4px;
                border-left: 5px solid #eee7ff;

                .headline {
                    display: flex;
                    width: 100%;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 12px;
                }
            }
        }
    }
}
</style>
